import { render, staticRenderFns } from "./FaqCategory.vue?vue&type=template&id=f2f809a0"
import script from "./FaqCategory.vue?vue&type=script&lang=js"
export * from "./FaqCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2f809a0')) {
      api.createRecord('f2f809a0', component.options)
    } else {
      api.reload('f2f809a0', component.options)
    }
    module.hot.accept("./FaqCategory.vue?vue&type=template&id=f2f809a0", function () {
      api.rerender('f2f809a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/FaqCategory.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FaqCategory.vue
// module id = 132
// module chunks = 0